// Shared palette + style primitives for the monitoring PDFs (period reports
// and the monthly share card). Keep this small and shared — styles used by
// exactly one document live in that document's own StyleSheet.
//
// Font families are the ones registered by ./fonts (registerReportFonts must
// run before any pdf() call). BODY (Inter) covers the full glyph set incl.
// ₹ / CO₂ / ≈; DISPLAY (Playfair Display) is latin-only — never put ₹ in
// display-set text.

export const COLORS = {
  ink: "#0d201d",
  muted: "#5a6e6a",
  deepGold: "#8a6826",
  gold: "#c9a460",
  paleGold: "#f4ead4",
  teal: "#237a6e",
  parchment: "#faf7f0",
  hairline: "#e6ddc8",
  white: "#ffffff",
};

export const BODY_FONT = "ReportBody";
export const DISPLAY_FONT = "ReportDisplay";
